<template>
  <Properties :component="component">
    <template #library-properties>
      <section
        class="layout-pt-lg layout-pb-lg tw-pt-36 md:tw-pt-52"
        :style="`background-color: var(--c-section_quaternary)`"
      >
        <div class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6">
          <div
            v-if="isExtendedFilterPopupVisible"
            class="tw-fixed tw-left-0 tw-top-0 tw-z-20 tw-h-screen tw-w-full tw-bg-black tw-opacity-40"
          ></div>
          <div class="tw-col-span-12 tw-w-full tw-pb-3">
            <div class="tw-block lg:tw-hidden">
              <lazy-library-properties-search-box
                v-model:filters="filters"
                v-model:locations="locations"
                v-model:search-input="searchInput"
                :search-type="searchType"
                @on-search="onSearch()"
                @open-extended-popup="openExtendedPopup()"
                :buy="vars.buyBool"
                :rent="vars.rentBool"
                version="v6"
                title=""
                :icon-only="false"
                :alternative-layout="true"
              />
            </div>
            <div class="tw-hidden lg:tw-block">
              <lazy-library-properties-search-box
                v-model:filters="filters"
                v-model:locations="locations"
                v-model:search-input="searchInput"
                :search-type="searchType"
                @on-search="onSearch()"
                @open-extended-popup="openExtendedPopup()"
                :buy="vars.buyBool"
                :rent="vars.rentBool"
                version="v7"
                title=""
                :icon-only="false"
                :alternative-layout="true"
              />
            </div>
            <template v-if="sidebarComponents && sidebarComponents.length">
              <div class="tw-flex tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-10">
                <h5>{{ filterSummary }}</h5>
                <div class="tw-flex tw-items-center tw-gap-6">
                  <div
                    v-if="isApplicantExist"
                    class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                    @click="onClickedProfile()"
                  >
                    <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                    <p class="tw-mr-2 tw-truncate tw-capitalize">
                      {{ contactSession.name }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="tw-py-4"></div>
            </template>
          </div>
          <template v-if="sidebarComponents && sidebarComponents.length === 0">
            <div
              class="tw-col-span-12 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-py-4 lg:tw-flex-nowrap"
            >
              <h6 class="tw-uppercase" style="color: var(--c-secondary)">{{ filterSummary }}</h6>
              <div v-if="isApplicantExist" class="tw-flex tw-items-center tw-gap-4">
                <div
                  v-if="isApplicantExist"
                  class="tw-me-3 tw-flex tw-cursor-pointer tw-items-center"
                  @click="onClickedProfile()"
                >
                  <span class="nc-icon-profile-user-1 tw-me-2" style="font-size: 24px"> </span>
                  <p class="tw-mr-2 tw-truncate tw-capitalize">
                    {{ contactSession.name }}
                  </p>
                </div>
              </div>
              <div class="tw-mt-6 tw-flex tw-w-full tw-justify-center md:tw-mt-12 lg:tw-mt-0 lg:tw-w-auto">
                <button v-if="!isApplicantExist" class="n-primary tw-w-full lg:tw-w-auto" @click="setupHeadsUpAlerts()">
                  REGISTER FOR ALERTS
                </button>
                <button v-if="isApplicantExist" class="n-primary tw-w-full lg:tw-w-auto" @click="updateHeadsUpAlerts()">
                  UPDATE ALERTS
                </button>
              </div>
            </div>
          </template>
          <div v-if="sidebarComponents && sidebarComponents.length" class="tw-order-2 tw-col-span-12 xl:tw-col-span-4">
            <div class="tw-flex tw-flex-col tw-gap-4 tw-pb-8">
              <theme8-available-components-for-sidebar
                key="property-sidebar"
                key-prefix="property-sidebar"
                :specific-components="sidebarComponents"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="layout-pt-lg layout-pb-lg tw-z-auto" :style="`background-color: var(--c-section_primary)`">
        <div class="container properties tw-grid tw-grid-cols-12 tw-items-start tw-gap-6">
          <div class="tw-col-span-12 tw-w-full tw-pb-3">
            <!-- Mobile layout (stacked vertically) -->
            <div class="tw-flex tw-flex-col tw-gap-4 md:tw-hidden">
              <h2 v-if="highlightedProperties.length === 0" class="tw-mb-4 tw-text-start">{{ count }} RESULTS</h2>
              <h2 v-else-if="highlightedProperties.length > 0 && properties.length" class="tw-text-center">
                Existing matches:
                {{ count }} - {{ highlightedProperties.length }}

                RESULTS
              </h2>
              <div class="tw-flex tw-justify-start">
                <library-properties-sort-box
                  v-if="highlightedProperties.length === 0"
                  v-model:filter-criteria="filterCriteria"
                  version="v2"
                  @on-sort="sort()"
                  class="tw-w-full"
                />
              </div>
            </div>
            <!-- Desktop layout (horizontal) -->
            <div class="properties-match-card tw-hidden tw-items-center tw-justify-between md:tw-flex">
              <h2 v-if="highlightedProperties.length === 0">
                <span
                  :style="
                    vars.searchTypeText === 'sales'
                      ? 'color: var(--c-secondary)'
                      : vars.searchTypeText === 'lettings'
                        ? 'color: var(--c-tertiary)'
                        : ''
                  "
                  >{{ count }}</span
                >
                RESULTS
              </h2>
              <h2 v-else-if="highlightedProperties.length > 0 && properties.length">
                Existing matches:
                <span
                  :style="
                    vars.searchTypeText === 'sales'
                      ? 'color: var(--c-secondary)'
                      : vars.searchTypeText === 'lettings'
                        ? 'color: var(--c-tertiary)'
                        : ''
                  "
                  >{{ count }} - {{ highlightedProperties.length }}</span
                >
                RESULTS
              </h2>
              <div class="tw-flex tw-items-center tw-gap-4">
                <library-properties-sort-box
                  v-if="highlightedProperties.length === 0"
                  v-model:filter-criteria="filterCriteria"
                  version="v2"
                  @on-sort="sort()"
                />
              </div>
            </div>
          </div>
          <div
            class="tw-col-span-12"
            :class="{
              'tw-order-1': sidebarComponents && sidebarComponents.length,
            }"
          >
            <div v-if="filterSummary">
              <div class="tw-py-5" v-if="isLoading">
                <loader />
              </div>
              <div v-else-if="!isLoading && (highlightedProperties.length || properties.length)">
                <div v-if="locations.length > 0" class="row g-0 mb-3">
                  <div class="col-12">
                    <location-boxes v-model:locations="locations" :is-first-location-excluded="true" />
                  </div>
                </div>
                <template v-if="highlightedProperties.length">
                  <div
                    v-if="highlightedProperties.length > 0"
                    class="row g-0 mb-5 d-flex flex-row justify-content-between"
                  >
                    <div class="col-md-8 col-12 tw-mb-4 md:tw-mb-0">
                      <lazy-library-title tag="h1" :text="`New matches: ${newMatchesPropertyCount} properties`">
                      </lazy-library-title>
                    </div>
                    <div class="col-md-4 col-xl-2 col-12 d-flex justify-content-end">
                      <lazy-library-properties-sort-box v-model:filter-criteria="filterCriteria" @on-sort="sort()" />
                    </div>
                  </div>
                  <lazy-library-properties-page-list
                    v-if="highlightedProperties.length > 0"
                    :component="component"
                    :properties="highlightedProperties"
                    :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                  />
                </template>
                <lazy-library-properties-page-list
                  :theme="theme"
                  :component="component"
                  :properties="properties"
                  :cards="cards"
                  :columns="vars.columnsNumber"
                  :pre-market-property-feature="vars.preMarketPropertyFeatureBool"
                  :version="vars.propertyListItemVersionText"
                  :pre-market-blur-text="vars.preMarketBlurredImageTextHtml"
                />
                <div v-if="isPropertiesGridLoadMoreActive" class="tw-flex tw-items-center tw-justify-center tw-py-8">
                  <button class="n-secondary" @click="loadMore()">LOAD MORE</button>
                </div>
              </div>
              <div v-else-if="properties && properties.length === 0" class="tw-h-[40vh] tw-py-5">
                <lazy-theme4-base-not-found
                  title="Unfortunately, there are no properties matching your search criteria."
                >
                  <template #description>
                    Please
                    <nuxt-link to="/heads-up-alerts/register" :external="true" class="n-link"
                      ><u class="unknown-user-text text">setup a Heads Up property alert</u></nuxt-link
                    >
                    to be kept up to date in the future with new suggested properties that are based around your
                    specific criteria.
                  </template>
                </lazy-theme4-base-not-found>
              </div>
              <advanced-search
                v-if="!isMobile && isExtendedFilterPopupVisible"
                v-model:filters="filters"
                v-model:is-available="searchInput.is_available"
                :search-type="searchType"
                @on-open-all-styles-popup="allStylesConfig.isActive = true"
                @close-advanced-filter="closeAdvancedFilter()"
                theme="theme4"
                :component="component"
                @open-extended-popup="turnOffExtendedPopup()"
              />
              <popup
                v-if="isMobile"
                :config="advancedSearchConfig"
                custom-width="auto"
                class="advanced-mobile-popup"
                :custom-wrapper-class="propertiesConfig.advancedSearchMobilePopupBackgroundClass"
              >
                <template #content>
                  <advanced-search
                    v-if="isExtendedFilterPopupVisible"
                    v-model:filters="filters"
                    v-model:is-available="searchInput.is_available"
                    :search-type="searchType"
                    @on-open-all-styles-popup="allStylesConfig.isActive = true"
                    @on-searched="onSearch()"
                    @close-advanced-filter="closeAdvancedFilter()"
                    @open-extended-popup="turnOffExtendedPopup()"
                    theme="theme4"
                  />
                </template>
              </popup>
              <popup v-if="allStylesConfig.isActive" v-model:config="allStylesConfig">
                <template #content>
                  <all-property-types-styles
                    v-model:selected-type-styles="filters.property_types"
                    @close="allStylesConfig.isActive = false"
                    variant="v2"
                  />
                </template>
              </popup>
              <popup
                v-if="applicantProfilesPopupConfig.isActive"
                v-model:config="applicantProfilesPopupConfig"
                custom-width="500px"
                class="applicant-profile-popup"
              >
                <template #content>
                  <applicant-profiles
                    :search-type="searchType"
                    @on-selected-new-applicant="onSelectedNewApplicant()"
                    :is-visible-update-button="vars.applicantProfilesUpdateButtonBool"
                  />
                </template>
              </popup>
            </div>
          </div>
        </div>
      </section>
    </template>
  </Properties>
</template>

<script lang="ts">
import Properties from '~/components/library/Properties.vue';
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme8Properties',

  mixins: [ComponentMixin],

  extends: Properties,

  components: {
    Properties,
  },

  computed: {
    cards() {
      return this.groupedVariables.cards;
    },
  },
});
</script>

<style scoped>
.block {
  font-size: 40em !important;
  font-weight: 900;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: 1;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: -80px !important;
  left: -90px !important;
}
</style>
